import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { nwasSSOAvailableAtom } from "@state/State";

export const useNWASSSO = (loadData: boolean = false) => {
  const [available, setAvailable] = useRecoilState<boolean>(nwasSSOAvailableAtom);

  useEffect(() => {
    if (loadData) {
      const checkIfSSOAvailable = async (): Promise<void> => {
        try {
          const response: Response = await fetch("https://parafolio-config.s3.eu-west-2.amazonaws.com/nwasSSO.json", {
            headers: {
              "Cache-Control": "no-cache",
            },
          });

          const result = await response.json();

          if (result != null) {
            setAvailable(true);
          }
        } catch (error) {
          setAvailable(false);
        }
      };

      checkIfSSOAvailable();
    }
  }, [loadData]);

  return available;
};
